export default __webpack_public_path__ + "static/media/vid2.46b8a673.mp4";